import React from 'react';
import { Field } from 'react-final-form';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import renderInput from '../../Fields/Input/Input';
import TextEditor from '../../TextEditor/TextEditor';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';


const AdNewFormDescriptions = ({ t, numberOfHighlights, }) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <Field
          component={TextEditor}
          label={t('main_description')}
          name="description"
          id="description"
        />
      </div>
      <div className={styles.highlights}>
        {[...Array(numberOfHighlights).keys()].map((item) => (
          <div className={styles.highlight} key={item}>
            <Field
              component={renderInput}
              label={`${t('highlights')} ${item + 1}`}
              name={`highlight_${item + 1}`}
              type="text"
              id={`highlight_${item + 1}`}
            />
          </div>
        )) }
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  row: {
    marginBottom: 15,
    positoin: 'relative',
  },
  highlights: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  highlight: {
    width: 'clamp(300px, 48%, 100%)',
  },
  container: {
    padding: '0px 15px',
  },
});

AdNewFormDescriptions.propTypes = {
  t: PropTypes.func.isRequired,
  numberOfHighlights: PropTypes.number,
};

AdNewFormDescriptions.defaultProps = {
  numberOfHighlights: 2,
};

export default withScopedTranslations('ad_vehicle_description')(AdNewFormDescriptions);
